import { render } from "./CVComponent.vue?vue&type=template&id=be85d254&scoped=true"
import script from "./CVComponent.vue?vue&type=script&lang=js"
export * from "./CVComponent.vue?vue&type=script&lang=js"

import "./CVComponent.vue?vue&type=style&index=0&id=be85d254&scoped=true&lang=css"

import exportComponent from "C:\\Users\\z4613\\Downloads\\461374167.github.io-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be85d254"]])

export default __exports__